import { render, staticRenderFns } from "./Suggest.vue?vue&type=template&id=e253ef5a&scoped=true"
import script from "./Suggest.vue?vue&type=script&lang=js"
export * from "./Suggest.vue?vue&type=script&lang=js"
import style0 from "./Suggest.vue?vue&type=style&index=0&id=e253ef5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e253ef5a",
  null
  
)

export default component.exports